var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8D48A389-6FDB-4B29-87E2-48DF49AD8136@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Teams-&-Roles",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Teams---Success-Alert",
    transform: "translate(-1229.000000, -598.000000)",
    fill: "#6C738A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(1216.000000, 583.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8947376,16.4736826 C19.3016843,16.4736826 19.6315798,16.8035781 19.6315798,17.2105248 C19.6315798,17.5884039 19.3471291,17.8998459 18.980669,17.9424097 L18.8947376,17.947367 L15.2105266,17.947367 C14.8326472,17.947367 14.5212054,18.2318174 14.4786417,18.5982777 L14.4736844,18.6842092 L14.4736844,26.7894734 C14.4736844,27.1673647 14.7581267,27.4787963 15.1245934,27.5213585 L15.2105266,27.5263156 L23.3157908,27.5263156 C23.6936908,27.5263156 24.005115,27.2418843 24.0476761,26.8754089 L24.052633,26.7894734 L24.052633,23.1052624 C24.052633,22.6983157 24.3825285,22.3684202 24.7894752,22.3684202 C25.1673543,22.3684202 25.4787964,22.6528709 25.5213602,23.019331 L25.5263174,23.1052624 L25.5263174,26.7894734 C25.5263174,27.9667338 24.6060814,28.9290148 23.4456783,28.9962476 L23.3157908,29 L15.2105266,29 C14.0332818,29 13.0709863,28.0797585 13.0037525,26.9193603 L13,26.7894734 L13,18.6842092 C13,17.5069701 13.9202566,16.5446693 15.0806413,16.4774351 L15.2105266,16.4736826 L18.8947376,16.4736826 Z M23.2263902,15.6474657 C24.0896226,14.7841781 25.4893279,14.7841781 26.3525603,15.6474657 C27.2158519,16.5106911 27.2158519,17.9103474 26.3525434,18.7736007 L26.3525434,18.7736007 L20.0261636,25.099975 C19.8879789,25.2381596 19.7005603,25.3157908 19.5051377,25.3157908 L19.5051377,25.3157908 L17.4210532,25.3157908 C17.0141065,25.3157908 16.684211,24.9858953 16.684211,24.5789486 L16.684211,24.5789486 L16.684211,22.4948623 C16.684211,22.2994397 16.7618423,22.1120212 16.9000268,21.9738365 L16.9000268,21.9738365 Z M25.3104747,16.6894846 C25.0227595,16.401751 24.556191,16.401751 24.2684594,16.689501 L24.2684594,16.689501 L18.1571586,22.8002097 L18.1571586,23.8421046 L19.1990534,23.8421046 L25.310508,17.7315316 C25.5761418,17.4659149 25.5965751,17.0479794 25.3718108,16.7589345 L25.3718108,16.7589345 Z",
    id: "edit"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "93daae63960c162387cf8aebd85e0034.svg";
export { ForwardRef as ReactComponent };